<div id="roles" class="page-layout blank simple" fxLayout="column">
  <!-- HEADER -->
  <div class="header">
    <div
      class="name field"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      {{ 'ROLES.TITLE' | translate }}
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content-card" fxFill>
    @if (isLoading) {
      <mat-progress-bar
        color="accent"
        mode="indeterminate"
        class="mat-progress-bar">
      </mat-progress-bar>
    } @else if (isErrorGetRoles) {
      <div>
        <div class="message-box error user-created">
          <app-error-message [error]="errorGetRoles.error" />
        </div>
      </div>
    } @else {
      <div class="content">
        <div class="row general-content">
          <div fxFlex="70" class="user-interface">
            @if (hasnoAssignableRole) {
              <div
                id="error-noservice"
                fxLayout="column"
                fxLayoutAlign="center center">
                <div
                  class="content"
                  fxLayout="column"
                  fxLayoutAlign="center center">
                  <div class="error-code">{{ 'ROLES.NOROLE' | translate }}</div>
                  <div class="message">
                    {{ 'ROLES.NOROLEDESC' | translate }}
                  </div>
                </div>
              </div>
            } @else {
              <div fxLayout="row" class="action-container">
                <div appearance="outline" fxFlex="60">
                  <div fxAlignLayout="start" fxFlex="60">
                    <mat-form-field appearance="outline" class="role-select">
                      <mat-label>{{ 'ROLES.SUBTITLE' | translate }}</mat-label>
                      <mat-select
                        [(ngModel)]="selectedRoleOid"
                        (selectionChange)="onRoleChange()">
                        @for (role of assignableRoles; track role) {
                          <mat-option [value]="role.oid">{{
                            role.displayName
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div appearance="outline" fxFlex="40" fxAlignLayout="end">
                  <div class="row" style="margin-top: 15px">
                    <div fxFlex="40" class="button-space"></div>
                    <button
                      mat-button
                      color="accent"
                      class="add-button"
                      (click)="affectUsers()">
                      <mat-label>{{ 'ROLES.AFFECTBTN' | translate }}</mat-label>
                    </button>
                  </div>
                </div>
                @if (isLoadingMembers) {
                  <div class="row" fxLayout="row" fxLayoutAlign="center center">
                    <mat-progress-spinner
                      [color]="spinner.color"
                      [mode]="spinner.mode"
                      [value]="spinner.value"
                      [diameter]="spinner.diameter">
                    </mat-progress-spinner>
                  </div>
                }
              </div>
              <div class="mat-elevation-z8">
                @if (!isLoadingMembers) {
                  <div fxLayoutGap="15px">
                    @if (!isLoading) {
                      <table
                        id="gridContainer"
                        mat-table
                        [dataSource]="dataSource"
                        matSort
                        (matSortChange)="sortData($event)"
                        multiTemplateDataRows>
                        <ng-container matColumnDef="firstName">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header="firstName"
                            class="sortable">
                            {{ 'TABLE.ROLES.HEADER.FIRSTNAME' | translate }}
                            <mat-icon
                              [style.color]="
                                sortedValue !== 'firstName'
                                  ? '#757575'
                                  : 'transparent'
                              "
                              class="sort-icon"
                              >sort</mat-icon
                            >
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.firstName }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="lastName">
                          <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header="lastName"
                            class="sortable">
                            {{ 'TABLE.ROLES.HEADER.LASTNAME' | translate }}
                            <mat-icon
                              [style.color]="
                                sortedValue !== 'lastName'
                                  ? '#757575'
                                  : 'transparent'
                              "
                              class="sort-icon"
                              >sort</mat-icon
                            >
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.lastName }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="username">
                          <th mat-header-cell *matHeaderCellDef>
                            {{ 'TABLE.ROLES.HEADER.USERNAME' | translate }}
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.username }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="delete">
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let element">
                            <button
                              mat-button
                              class="delete-button"
                              (click)="deleteUser(element)">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="expand">
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let element">
                            <button
                              mat-icon-button
                              (click)="toggleRow(element)">
                              <mat-icon>more_horiz</mat-icon>
                            </button>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="expandedDetail">
                          <td
                            mat-cell
                            *matCellDef="let element"
                            [attr.colspan]="displayedColumns.length">
                            @if (
                              expandedElement === element && windowWidth < 500
                            ) {
                              <div class="expanded-detail">
                                <p>
                                  <strong
                                    >{{
                                      'TABLE.ROLES.HEADER.USERNAME' | translate
                                    }}:</strong
                                  >
                                  {{ element.username }}
                                </p>
                                @if (windowWidth < 400) {
                                  <p>
                                    <button
                                      mat-button
                                      class="delete-button"
                                      (click)="deleteUser(element)">
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  </p>
                                }
                              </div>
                            }
                          </td>
                        </ng-container>
                        <tr
                          mat-header-row
                          *matHeaderRowDef="displayedColumns"></tr>
                        <tr
                          mat-row
                          *matRowDef="
                            let row;
                            let index = dataIndex;
                            columns: displayedColumns
                          "
                          class="element-row"
                          [ngClass]="{ alternate: index % 2 === 0 }"></tr>
                        <tr
                          mat-row
                          *matRowDef="
                            let row;
                            let index = dataIndex;
                            columns: ['expandedDetail']
                          "
                          class="detail-row"
                          [ngClass]="{ alternate: index % 2 === 0 }"></tr>
                      </table>
                    }
                  </div>
                }
                <mat-paginator
                  [style.display]="
                    dataSource?.data?.length > 6 ? 'block' : 'none'
                  "
                  [hidePageSize]="true"
                  [pageSize]="6"
                  showFirstLastButtons>
                </mat-paginator>
              </div>
            }
          </div>
          <app-roles-descriptions fxFlex="30" class="info-interface" />
        </div>
      </div>
    }
  </div>
</div>
